import type { FaireProductEntity } from "../../entity_types/product";

export const p_8sf7m8t2nj: FaireProductEntity = {
  token: "p_8sf7m8t2nj",
  type: "product",
  name: "ViA HEAT LOVE | Insulated Crystal Tea Bottle",
  brandToken: "b_6jphlq246l",
  brandName: "VitaJuwel USA",
  imageUrl:
    "https://cdn.faire.com/fastly/c1b1dc472e95bdf45ceaa0db2bd535deec671c23e010a3ed67596a6cc8253b64.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/452821bd7006e0e352ebc88caf2f5981995b156fd257324c8933b45d4d1ccf40.jpeg",
    "https://cdn.faire.com/fastly/6fb70289f139d338fe66412d297cd44a5b262b01bf116487fa49d0d24b7a0d9b.jpeg",
    "https://cdn.faire.com/fastly/77be682ddeb4137a7f224f3e7da9700aeb8767a0187e6dfd491b7b50add07410.jpeg",
  ],
  priceDollars: 74.83,
  description:
    "Rose Quartz, Garnet & Clear Quartz\nHARMONY  COMPASSION  AFFECTION\n\nCRYSTAL VIBES. Our 12.2 fl.oz. insulating glass bottle with a holistic blend of genuine crystals infuses your warm or cool drink with positive energy on-the-go. Naturopathic doctors have been using the vibrant energy of precious stones to prepare potent crystal elixirs for their therapies for many years. With the help of gemologists we’ve reinterpreted this tradition and created a select number of unique crystal blends aimed at specific crystal attributes.\n\nVERSATILE & PRACTICAL. Choose one of 13 traditional gemstone blends. Enjoy your loose leaf tea with the (optional) large capacity, stainless steel tea strainer. ViA HEAT is easy to clean, due to the two openings of the glass part.\n\nSUSTAINABLE. Stop using paper cups from your coffee shop and let them fill your ViA HEAT instead. ViA HEAT is 100% BPA-free.",
  tags: [],
  msrpDollars: 149.65,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:57:48.069Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
